
import { all, fork, put, select, takeEvery } from "redux-saga/effects";
import { SignalRTypes, SportTypesActionTypes,SportEventsActionTypes } from '../actions';
import { Enums } from "../../helpers";

export function* requests() {

    yield takeEvery(SignalRTypes.Default_Live_Sport_Type_Response, function* ({ response }) {
        try {
            window.console.response("Default_Live_Sport_Type_Response", response);

            switch (response.status) {
                case 1:
                    yield put({
                        type: SportEventsActionTypes.Get_Default_Live_Sport_Type_Success,
                        defaultLiveSport: response.data,
                    })
                    
                    break;

                case 3:
                    yield put({
                        type: SportEventsActionTypes.Get_Default_Live_Sport_Type_Error,
                        defaultLiveSportError: response.message,
                    })
                    break;

            }

        }
        catch (e) {
            window.log("ERROR", e)

        }
    })
}
export default function* DefaultLiveSportSaga() {
    yield all([
        fork(requests),
    ])
}
